import { registerLocaleData } from "@angular/common";
import { MatIconRegistry } from '@angular/material/icon';
// Register the french locale.
import localeFr from '@angular/common/locales/fr';
import { LoadDrupalLangService } from "src/app/common-page-components/services/load-drupal-lang.service";
registerLocaleData(localeFr);
const ɵ0 = () => LoadDrupalLangService.getRawLang();
export class ComponentsModule {
    constructor(matIconRegistry) {
        this.matIconRegistry = matIconRegistry;
    }
}
export { ɵ0 };
